import React from 'react';
import { NavLink } from 'react-router-dom';

function ContractNav() {
  /* eslint-disable jsx-a11y/anchor-is-valid, jsx-a11y/href-no-hash */
  return (
    <ul className="submenu">
      <li>
        <NavLink href="/contract/new" to="/contract/new">
          New ERC20 Token
        </NavLink>
      </li>
      <li>
        <NavLink href="/contracts" to="/contracts">
          Manage Contracts
        </NavLink>
      </li>
      <li>
        <a
          href="https://coinmarketcap.com/currencies/blockcat/#markets"
          target="_blank"
          rel="noopener noreferrer"
        >
          Fund Account
        </a>
      </li>
    </ul>
  );
  /* eslint-enable */
}

export default ContractNav;



// WEBPACK FOOTER //
// ./src/components/ContractNav.js